import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/169.png'


const _withScopeId = n => (_pushScopeId("data-v-77229a05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i169",
  src: _imports_0
}, null, -1))
const _hoisted_3 = ["id"]

import { inject, onBeforeUnmount, onBeforeMount, onMounted, ref, watch, reactive } from 'vue';
import ViewContext from '../ViewContext';

export default /*#__PURE__*/_defineComponent({
  props: {
    url: null,
    poster: null
  },
  setup(__props: any) {

const props = __props as {
    url: string,
    poster?: string,
}

const context = inject('context') as ViewContext

const temp = reactive({
    vdom: '',
})
const player = ref<any>()
const video = ref()
watch(() => props.url, () => {
    if (props.url) {
        createPlayer(props.url)
    }
})
onBeforeMount(() => {
    temp.vdom = 'video' + context.generateId()
})
onMounted(() => {
    if (props.url) {
        createPlayer(props.url)
    }
})

onBeforeUnmount(() => {
    if (player.value) {
        context.dispostAliPlayer(temp.vdom, player.value)
    }
})

function createPlayer(source: string) {
    context.dispostAliPlayer(temp.vdom, player.value)
    player.value = context.createAliPlayer(temp.vdom, source, function () {
    }, { auto: false, poster: props.poster || '', isLive: false, rate: true, isAudio: false })
    player.value.on('play', () => {
        context.registerMedia(doStop)
    })
}

function doStop() {
    if (player.value) {
        player.value.pause()
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "video-player",
      ref_key: "video",
      ref: video,
      id: _unref(temp).vdom
    }, null, 8, _hoisted_3)
  ]))
}
}

})